// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container_Sryud","pages":"Pagination_pages_khF2v","active":"Pagination_active_sbpsq"};